import React from 'react';

import ValueRows from '~components/visualisation/value-row/ValueRows';

interface LegendItem {
  title: string;
  value: number | string;
  color: string;
}

interface ChartLegendProps {
  data: LegendItem[];
}

const ChartLegend: React.FC<ChartLegendProps> = ({ data }) => {
  return <ValueRows data={data} />;
};

export default ChartLegend;
